export default "__VITE_ASSET__531f2c77__"